export default "__VITE_ASSET__DRqFYNX7__"